export default __webpack_public_path__ + "static/llama-fire-danger-screenshot-5eb285f066027b3a0fe994752ec10d2e.png";